export default ['ENGLISH', 'SPANISH', 'KOREAN', 'CHINESE', 'HINDI'];
